import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type {
  FontesPendenciaPublicacaoPagina,
  ListarFontesPendenciaPublicacaoInput,
} from '../../types/pendenciasPublicacaoTypes';

export async function listarFontesPendenciaPublicacaoService({
  id,
  pendenciaId,
  page = 1,
}: ListarFontesPendenciaPublicacaoInput): Promise<FontesPendenciaPublicacaoPagina> {
  const response = await apiGet(
    `/arbitral/painel/processos/${id}/pendencias/${pendenciaId}/fontes-publicacao?page=${page}&limit=10`,
  );
  if (!response.ok) await throwApiError(response, 'Não foi possível conferir as manifestações.');
  const result = await response.json();
  return result.data as FontesPendenciaPublicacaoPagina;
}
